export const siteConfig = {
  whatsappNumber: '5514991784044',
  whatsappDisplay: '(14) 99178-4044',
  instagramUrl: 'https://www.instagram.com/monise.sites',
  instagramHandle: '@monise.sites',
  logoRound: '/favicon-192.png',
  formEndpoint: process.env.REACT_APP_FORM_ENDPOINT || '/api/orcamento.php',
};

export const orcamentoOptions = {
  tipoServico: [
    'Site institucional',
    'Landing page',
    'Sistema personalizado',
    'Outro',
  ],
  situacaoSite: [
    'Não tenho site',
    'Tenho site, mas quero refazer',
    'Tenho site, mas quero melhorar',
    'Não sei / preciso de orientação',
  ],
  prazo: [
    'Urgente (até 15 dias)',
    'Em até 30 dias',
    'Em até 60 dias',
    'Sem pressa definida',
  ],
  origem: [
    'Instagram',
    'Google',
    'Indicação',
    'Já conhecia meu trabalho',
    'Outro',
  ],
};
